import React from "react";
import { Globe, ToggleLeft, ToggleRight } from "lucide-react";

const RegionScopeCard = ({ activeRegions, toggleRegion }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 h-full p-5 flex flex-col">
      <div className="flex items-center gap-2 mb-4 text-slate-800">
        <Globe size={20} className="text-blue-600" />
        <h3 className="font-bold text-lg">Active Regions</h3>
      </div>

      <div className="space-y-4 flex-1">
        {["India", "Asia"].map((region) => (
          <div
            key={region}
            className="flex items-center justify-between p-3 bg-slate-50 rounded-lg border border-slate-100"
          >
            <span className="font-medium text-slate-700">{region}</span>
            <button
              onClick={() => toggleRegion(region)}
              className="text-blue-600 hover:text-blue-700 focus:outline-none"
            >
              {activeRegions[region] ? (
                <ToggleRight size={32} />
              ) : (
                <ToggleLeft size={32} className="text-slate-300" />
              )}
            </button>
          </div>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-slate-100">
        <p className="text-xs text-slate-500">
          Toggling off a region hides it from the export pack but preserves
          data.
        </p>
      </div>
    </div>
  );
};

export default RegionScopeCard;
